import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ElementRef,
} from "@angular/core";
import { MasterService } from "../../master/services/master-service";
import { CommonHelper } from "../../../helper/helper.component";
import { CommonConstants } from "../../../shared/constants";
import { NgxSpinnerService } from "ngx-spinner";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { DatePipe } from "@angular/common";
import { Router } from "@angular/router";
import { DataService } from "../../../shared/service/data.service";

@Component({
  selector: "app-add-user-master",
  templateUrl: "./add-user-master.component.html",
  styleUrls: ["./add-user-master.component.scss"],
  providers: [MasterService, CommonHelper, DatePipe],
})
export class AddUserMasterComponent implements OnInit {
  submitted = false;
  addUserForm: FormGroup;
  roleValueForEdit: any;
  userTitleData: any;
  errorOrResponse = false;
  userData: any;
  dateFormateValueDob: string = "";
  dateFormateValueDoj: string = "";
  editUserForm: any;
  dateConversion: boolean;
  statesData: any;
  districtsDataPermanent: any;
  districtsDataCurrent: any;
  talukas: any = [];
  districts: any = [];
  multipleDistrict: any;
  designationsData: any;
  levelData: any;
  stateIdPermanent: number;
  stateIdCurrent: number;
  selectedStateEvent: any;
  selectedDesignationsEvent: any;
  dateValid: boolean = false;
  dateValidDoj: boolean = false;
  selectedDistrictEvent: any;
  selectedLevelEvent: any;
  selectedRoleEvent: any;
  maritalStatusData: any;
  dataTable: any;
  religionData: any;
  communityData: any;
  rolesData: any;
  checkAddressType: number;
  selectedgender: any;
  selectedLevel: any;
  selectedDistrict: any;
  selectedState: any;
  sameAddress: boolean;
  bsValue = new Date();
  addUser: boolean = true;
  editDataUser: any;
  bsRangeValue: Date[];
  userId: number;
  maxDate = new Date();
  minDate = new Date();
  maxDateJoin = new Date();
  maxDateEdit = new Date();
  maxDateEditJoin = new Date();
  districtIds = {};
  districtIdsData: any = [];
  submitName = "";
  stateId: number;
  isDislayDistrict: boolean = false;
  isDislayBlock: boolean = false;
  isDislayState: boolean = false;
  showPassword: string = CommonConstants.passwordDefaultValue;
  defaultStateValue: number;
  multipleTalukas: any;
  showTime = true;
  events: any = [];
  userType: any;
  talukasIds: any;
  talukasData: any = [];
  checkTalukas: any;
  counter = 0;
  categories: any = [];
  categoriesNature: any = [];
  selectedNature: any;
  natureId: any = [];
  gId: any = [];
  roleId: number;
  // grievanceObj: any = {};
  // grievanceNatureObj: any = {};
  // grievanceArray: any = [];
  // grievanceNatureArray: any = [];
  // grievanceArrayId: any = [];
  // grievanceNatureArrayId: any = [];
  userLocation: string;
  userState: string;
  userDistrict: any = [];
  newUserDistrict: any = [];
  userBlock: any = [];
  addGrievance: any = [];
  addNature: any = [];
  multpleEmail: any = [];
  multipleContact: any = [];
  selectedCategory: any;
  emailValue: any = [];
  contactValue: any = [];
  myDateValue: Date;
  startDateTime: any;
  showPickerStart: any;
  rolesDummy: any;

  constructor(
    public datepipe: DatePipe,
    public dataService: DataService,
    public router: Router,
    private masterService: MasterService,
    private chRef: ChangeDetectorRef,
    private commonHelper: CommonHelper,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder
  ) {
    this.sameAddress = true;
  }

  ngOnInit() {
    if (this.dataService.editUser == "editUserDetails") {
      if (this.dataService.editUser != undefined) {
        this.submitName = "Update User";
        this.dataService.getCurrentUserDetails.subscribe(
          (message) => (this.editDataUser = message)
        );
        this.addUser = false;
      }
    } else if (this.dataService.editUser == "addUserDetails") {
      this.submitName = "Create User";
      this.addUser = true;
    }
    this.getStates();

    this.getDesignations();
    // this.getCategories();
    // this.getLevels(this.gId, this.natureId, CommonConstants.stateId);
    this.getRoles(CommonConstants.stateId);
    this.userTitleData = CommonConstants.title;
    this.selectedgender = CommonConstants.gender;
    this.selectedState = CommonConstants.state;
    // this.selectedDistrict = CommonConstants.districts;
    this.selectedLevel = CommonConstants.userType;
    // this.rolesDummy = CommonConstants.roles;

    this.submitted = false;
    this.validatorRule();
    this.minDate.setDate(this.minDate.getDate() - 1);
    this.maxDateJoin.setDate(this.maxDate.getDate());
    this.myDateValue = new Date();
    this.bsRangeValue = [this.bsValue, this.maxDate];
    this.checkAddressType = CommonConstants.checkBeforeAddressType;
    this.sameAddress = true;
    this.rolesData = [];
    this.levelData = [];
    this.designationsData = [];
    this.stateIdCurrent = null;
    this.stateIdPermanent = null;
    // this.addUserForm.controls['addUserAddressState'].disable();
    // this.addUserForm.controls["addUserCurrentState"].disable();
    // this.addUserForm.controls["addUserLocationState"].disable();
  }

  /*validation rules*/
  validatorRule() {
    // let dateStartDate = this.datepipe.transform(this.startDateTime, "yyyy-MM-dd");
    if (this.addUser == true) {
      this.addUserForm = this.fb.group({
        addUserTitle: [[]],
        addUserFirstName: [
          "",
          [
            Validators.required,
            Validators.maxLength(CommonConstants.maxLength150),
            Validators.minLength(2),
            Validators.pattern(CommonConstants.regexNotAllowSpace),
          ],
        ],
        addUserMiddleName: [
          "",
          [
            Validators.maxLength(CommonConstants.maxLength150),
            Validators.pattern(CommonConstants.regexNotAllowSpace),
          ],
        ],
        addUserLastName: [
          "",
          [
            Validators.required,
            Validators.maxLength(CommonConstants.maxLength150),
            Validators.minLength(2),
            Validators.pattern(CommonConstants.regexNotAllowSpace),
          ],
        ],
        addUserGender: [[]],
        addContactNo: ["", [Validators.pattern(CommonConstants.regexNotAllowZeroMobileNumber),]],
        addEmergencyContactNo: [
          "",
          [
            Validators.pattern(CommonConstants.regexNotAllowZeroMobileNumber),
          ],
        ],
        addUserEmail: ["", [Validators.required, Validators.pattern(CommonConstants.emailRegex)]],
        addUserName: ["", [Validators.required, Validators.pattern(CommonConstants.regexNotAllowSpaceUserName)]],
        addUserPassword: [
          "",
          [
            Validators.required,
            Validators.pattern(CommonConstants.passwordNotAllowSpaceRegex),
          ],
        ],
        addUserDOJ: [""],
        addUserAddressState: [[], [Validators.required]],
        addUserAddressDistrict: [[]],
        addUserType: [[]],
        addUserAddressPincode: [
          "",
          [Validators.pattern(CommonConstants.regexPinCode)],
        ],
        addUserDesignations: [[]],
        addUserRoles: [[], [Validators.required]],
      });
    } else if (this.addUser == false) {
      this.userId = this.editDataUser.id;
      this.sameAddress = true;
      this.getDistricts(this.editDataUser.state.id);

      if (this.editDataUser.title) {
        if (!this.editDataUser.title["name"]) {
          this.editDataUser.title = { name: this.editDataUser.title };
        }
      }
      else {
        this.editDataUser.title = { name: '' };
      }
      if (this.editDataUser.gender) {
        if (!this.editDataUser.gender["name"]) {
          this.editDataUser.gender = { name: this.editDataUser.gender };
        }
      }
      else {
        this.editDataUser.gender = { name: '' };
      }

      if (this.editDataUser.dateOfJoining) {
        if (!this.editDataUser.dateOfJoining["name"]) {
          this.editDataUser.dateOfJoining = {
            name: this.editDataUser.dateOfJoining
          };
        }
      }
      else {
        this.editDataUser.dateOfJoining = { name: '' };
      }
      if (this.editDataUser.roles) {
        if (this.editDataUser.roles["name"]) {
          this.editDataUser.roles = {
            id: this.editDataUser.roles.id,
            name: this.editDataUser.roles.name,
          };
        }
      }
      else {
        this.editDataUser.roles = { id: '', name: '' };
      }

      // if (this.editDataUser.gender.name == this.selectedgender.id){
      //   // this.editDataUser.gender.name = this.selectedgender.name;
      // }


      this.userDistrict = [];
      this.userBlock = [];
      // let dateStartDate = this.datepipe.transform(this.editDataUser.dateOfJoining.name, "yyyy-MM-dd");
      // let dateStartDate = this.datepipe.transform(this.startDateTime, "yyyy-MM-dd");

      this.addUserForm = this.fb.group({
        addUserTitle: [this.editDataUser.title ? this.editDataUser.title.name : ''],

        addUserFirstName: [this.editDataUser.firstName, [Validators.required, Validators.maxLength(CommonConstants.maxLength150),
        Validators.minLength(4),
        Validators.pattern(CommonConstants.regexNotAllowSpace),]],
        addUserMiddleName: [this.editDataUser.middleName, Validators.pattern(CommonConstants.regexNotAllowSpace)],
        addUserLastName: [this.editDataUser.lastName, [Validators.required, Validators.maxLength(CommonConstants.maxLength150),
        Validators.minLength(2),
        Validators.pattern(CommonConstants.regexNotAllowSpace),]],
        addUserGender: [this.editDataUser.gender.name],
        addContactNo: [this.editDataUser.contactNumber, [Validators.pattern(CommonConstants.regexNotAllowZeroMobileNumber)]],
        addEmergencyContactNo: [
          this.editDataUser.emergencyContactNumber,
          [
            Validators.pattern(CommonConstants.regexNotAllowZeroMobileNumber),
          ],
        ],

        addUserEmail: [this.editDataUser.email, [Validators.required, Validators.pattern(CommonConstants.emailRegex)]],
        addUserName: [this.editDataUser.userName, [Validators.required, Validators.pattern(CommonConstants.regexNotAllowSpaceUserName)]],
        addUserDOJ: [this.editDataUser.dateOfJoining.name],
        addUserAddressState: [this.editDataUser.state.name, [Validators.required]],//[addressStates],
        addUserType: [this.editDataUser.userType],
        addUserAddressDistrict: [this.editDataUser.district.name],
        addUserAddressPincode: [
          this.editDataUser.pincde,
          [Validators.pattern(CommonConstants.regexPinCode)],
        ],
        addUserDesignations: [
          this.editDataUser.designations
        ],
        addUserRoles: [this.editDataUser.roles, [Validators.required]],
      });
      this.addUserForm.removeControl("addUserPassword");
    }
  }



  // password validation
  passwordValidator(control) {
    // Check if password contains any spaces
    if (/\s/.test(control.value)) {
      return { invalidPassword: true };
    }
    // Check if password contains only alphanumeric characters
    if (!/^[a-zA-Z0-9]*$/.test(control.value)) {
      return { invalidPassword: true };
    }
    return null;
  }

  /**
   * Password show
   * @param value
   */
  passwordShow(value: string) {
    this.showPassword = value === "show" ? "text" : "password";
  }
  /*get states*/
  getStates() {
    try {
      this.masterService.getAll("active_states").subscribe((response: any) => {
        if (response.status == 200) {
          if (response.data.length != 0) {
            this.statesData = response.data;
            this.districtIdsData.push({ stateId: CommonConstants.stateId });
            let selectedValue: any;
            response.data.forEach((element) => {
              if (element.id == CommonConstants.stateId) {
                selectedValue = element;
              }
            });
            this.defaultStateValue = selectedValue;
            this.validatorRule();
          }
        } else {
          this.commonHelper.toasterMessageError(
            CommonConstants.validationMessage
          );
          this.statesData = [];
          this.commonHelper.toasterMessageError(CommonConstants.statesMessage);
        }
      });
    } catch (exc) {
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
  }

  // function for copying same address as permanent address
  copyAddressCurrent() {
    this.addUserForm.controls["addUserAddressState"].setValue(
      this.addUserForm.value.addUserCurrentState
    );
    this.addUserForm.controls["addUserAddressDistrict"].setValue(
      this.addUserForm.value.addUserCurrentDistrict
    );
    this.addUserForm.controls["addUserAddressLine1"].setValue(
      this.addUserForm.value.addUserCurrentAddressLine1
    );
    this.addUserForm.controls["addUserAddressLine2"].setValue(
      this.addUserForm.value.addUserCurrentAddressLine2
    );
    this.addUserForm.controls["addUserAddressPincode"].setValue(
      this.addUserForm.value.addUserCurrentPinCode
    );
  }
  // Change function for address type
  checkSameAddress(event, value) {
    if (value == "addChange") {
      if (event.target.checked == true) {
        this.sameAddress = false;
        this.districtsDataCurrent = [];
        this.districtsDataPermanent = [];
        // this.getDistricts(CommonConstants.stateId, value, "currentAddress");
        this.checkAddressType = CommonConstants.checkAfterAddressType;
        this.copyAddressCurrent();
      } else {
        this.sameAddress = true;
        this.checkAddressType = CommonConstants.checkBeforeAddressType;
        let apiValues = this.addUserForm.value;
        this.districtsDataPermanent = [];
        this.copyAddressCurrent();
        // this.getDistricts(CommonConstants.stateId, value, "permanentAddress");
      }
    }
  }

  districts1: any = [];
  districtsData1: any;

  /*state change event*/
  onStateChange(event, value, addressType) {
    this.addUserForm.get('addUserAddressDistrict').setErrors(null);
    this.addUserForm.get('addUserAddressDistrict').markAsUntouched();
    // Update placeholder dynamically
    this.addUserForm.get('addUserAddressDistrict').updateValueAndValidity();
    this.addUserForm.controls["addUserAddressDistrict"].setValue([]);

    this.getDistricts(event.id);
  }

  /**
   *
   * @param stateId
   * @param value
   */
  // , value, addressType
  getDistricts(stateId) {
    try {
      this.masterService
        .getData("active_districts/", stateId)
        .subscribe((response: any) => {
          if (response.data) {
            // if (value === "addChange") {
            //   if (addressType == "currentAddress") {
            if (stateId == response.data[0].stateId) {
              this.districtsDataCurrent = response.data[0].districts;

            } else {
              this.addUserForm.get("addUserAddressDistrict").setValue([]);
              this.districtsDataCurrent = [];
            }
          } else {
            this.commonHelper.toasterMessageError(
              CommonConstants.validationMessage
            );

            this.addUserForm.get("addUserAddressDistrict").setValue([]);
            this.districtsDataCurrent = [];

          }
        });
    } catch (exc) {
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
  }

  //change District event
  changeDistrict(event) {
    this.districts = [];
    this.districtIdsData = [];
    if (event.length == 0) {
      this.talukasData = [];
      this.addUserForm.controls["addUserBlockLocation"].reset();
    } else {
      if (event.length != this.counter) {
        this.addUserForm.controls["addUserBlockLocation"].reset();
        this.counter = event.length;
      }
      event.map((data) => {
        this.districtIds = {
          stateId: CommonConstants.stateId,
          districtId: data.districtId,
        };
        this.districtIdsData.push(this.districtIds);
        this.districts.push(data.districtId);
        this.getBlock();
      });
    }
  }

  //change Talukas event
  changeTalukas(event) {
    this.districtIdsData = [];
    event.map((data) => {
      this.talukasIds = {
        stateId: CommonConstants.stateId,
        talukaId: data.talukaId,
      };
      this.districtIdsData.push(this.talukasIds);
    });
  }

  // get Block
  getBlock() {
    try {
      let data = {
        district_id: this.districts,
      };
      this.masterService.postData("talukas", data).subscribe(
        (response: any) => {
          this.talukas = [];
          this.talukasData = [];
          if (response.status) {
            response.data.map((data) => {
              this.talukasData.push(data);
              this.talukas.push(data.name);
            });
          } else {
            this.commonHelper.toasterMessageError(
              CommonConstants.validationMessage
            );
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (exc) {
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
  }

  // clear the search
  clearFilter(value1) {
    if (value1 == false) {
      this.counter = this.counter - 1;
      this.addUserForm.controls["addUserBlockLocation"].reset();
    } else {
      this.counter = this.counter + 1;
    }
  }


  /** get designations
   *
   * @param stateId
   */
  getDesignations() {
    try {
      this.masterService
        .getAll("active_designations")
        .subscribe((response: any) => {

          if (response.status == 200) {
            if (response.data.length > 0) {
              this.designationsData = response.data;
            } else {
              this.designationsData = [];
            }
          } else {
            this.commonHelper.toasterMessageError(
              CommonConstants.validationMessage
            );
            this.addUserForm.get("addUserDesignations").setValue([]);
            this.selectedDesignationsEvent = [];
          }
        });
    } catch (exc) {
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
  }
  filterRoles(item: any) {
    status: 'inactive'
    return item.status !== 'inactive'; // Only show items with an ID other than 1
  }


  filteredRoles: any = [];
  /*get states*/
  getRoles(stateId) {
    try {
      this.masterService
        .getRoleData("roles")
        .subscribe((response: any) => {
          if (response.status == 200) {
            if (response.data.length > 0) {
              this.rolesData = response.data;
              // Filter the items array to create a new array that only contains items that meet the condition
              this.filteredRoles = this.rolesData.filter(this.filterRoles);
            } else {
              this.rolesData = [];
            }
          } else {
            this.commonHelper.toasterMessageError(
              CommonConstants.validationMessage
            );
            this.addUserForm.get("addUserLevels").setValue([]);
            this.rolesData = [];
          }
        });
    } catch (exc) {
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
  }

  //get f() { return this.addUserForm.controls; }
  get addUserF() {
    return this.addUserForm.controls;
  }
  //get f() { return this.editUserForm.controls; }
  get editUserF() {
    return this.editUserForm;
  }

  //function to check date is valid or not
  dateValidFun(event) {
    this.dateFormateValueDob = event.target.value;
    if (event.target.value == "Invalid date") {
      this.dateValid = true;
    } else if (event.target.value == "") {
      this.dateValid = false;
    }
  }
  dateValidFunDoj(event) {
    this.dateFormateValueDoj = event.target.value;
    if (event.target.value == "Invalid date") {
      this.dateValidDoj = true;
    } else if (event.target.value == "") {
      this.dateValidDoj = false;
    }
  }

  // Change Role
  onChangeRole(event: any) {
    this.addUserForm.value.addUserRoles = event.id;
    this.roleValueForEdit = event.id;
  }

  /* Adding users */
  createUser() {
    this.submitted = true;
    this.errorOrResponse = false;
    this.spinner.show();
    if (this.dateFormateValueDob == "") {
      this.dateValid = false;
    } else if (this.dateFormateValueDob == "Invalid date") {
      this.dateValid = true;
    }
    if (this.dateFormateValueDoj == "") {
      this.dateValidDoj = false;
    } else if (this.dateFormateValueDoj == "Invalid date") {
      this.dateValidDoj = true;
    }
    if (this.addUserForm.value.addUserAddressDistrict == null) {
      this.addUserForm.value.addUserAddressDistrict = "";
      this.addUserForm.value.addUserAddressDistrict.id;
    }
    if (this.addUserForm.value.addUserAddressState == null) {
      this.addUserForm.value.addUserAddressState = "";
    }
    if (this.addUser == false) {
      if (!this.addUserForm.value.addUserRoles['roleId']) {
        this.addUserForm.value.addUserRoles = this.editDataUser.roles
      }
      if (!this.addUserForm.value.addUserDesignations["designationsId"]) {
        this.addUserForm.value.addUserDesignations.designationsId =
          this.addUserForm.value.addUserDesignations.id;
      }
      if (this.addUserForm.value.addUserAddressDistrict != "") {
        if (!this.addUserForm.value.addUserAddressDistrict["districtId"]) {
          this.addUserForm.value.addUserAddressDistrict =
            this.addUserForm.value.addUserAddressDistrict;
        }
      }
    }



    // pass the field to be add
    if (this.submitName == "Create User") {
      this.addUserForm.value.addUserTitle =
        this.addUserForm.value.addUserTitle;
      // this.addUserForm.value.addUserRoles = this.addUserForm.value.addUserRoles;
      this.addUserForm.value.addUserGender =
        this.addUserForm.value.addUserGender;
      this.addUserForm.value.addUserType =
        this.addUserForm.value.addUserType.name;
      this.addUserForm.value.addUserRoles = this.addUserForm.value.addUserRoles.id;
    }

    let apiValues = this.addUserForm.value;
    if (apiValues.addUserPassword == undefined) {
      apiValues.addUserPassword = "";
    }
    let gender: any;
    if (this.submitName == "Update User") {

      apiValues.addUserRoles = this.addUserForm.value.addUserRoles.id;
      if (apiValues.addUserGender.name === "Male") {
        this.editDataUser.gender = { name: "M" }
      } else if (apiValues.addUserGender.name === "Female") {
        this.editDataUser.gender = { name: "F" }
      } else if (apiValues.addUserGender.name === "Transgender") {
        this.editDataUser.gender = { name: "T" }
      } else {
        this.editDataUser.gender = { name: "O" }
      }
      // if (apiValues.addUserGender.id === undefined) {
      //   // apiValues.addUserGender.id = gender;
      //   // this.editDataUser.gender.name = gender;
      // 
      if (apiValues.addUserType && apiValues.addUserType.name) {
        apiValues.addUserType =
          apiValues.addUserType.name;
        // apiValues.addUserDOJ = this.datepipe.transform(this.startDateTime, "yyyy-MM-dd");
      }

      let data =
      {
        userName: apiValues.addUserName,
        password: apiValues.addUserPassword,
        title: apiValues.addUserTitle.name ? apiValues.addUserTitle.name : "",
        firstName: apiValues.addUserFirstName,
        middleName: apiValues.addUserMiddleName,
        lastName: apiValues.addUserLastName,
        gender: apiValues.addUserGender.id ? apiValues.addUserGender.id : "",
        contactNumber: apiValues.addContactNo,
        designationId: apiValues.addUserDesignations.designationsId ? apiValues.addUserDesignations.designationsId : "",
        emergencyContactNumber: apiValues.addEmergencyContactNo,
        email: apiValues.addUserEmail,
        roleId: this.roleValueForEdit ? this.roleValueForEdit : apiValues.addUserRoles,
        // apiValues.addUserRoles.roleId == null
        //   ? this.editDataUser.roles.id
        //   : apiValues.addUserRoles.roleId,
        dateOfJoining: apiValues.addUserDOJ,
        stateId: apiValues.addUserAddressState.id ? apiValues.addUserAddressState.id : this.editDataUser.state.id,
        districtId: apiValues.addUserAddressDistrict.districtId ? apiValues.addUserAddressDistrict.districtId : "",
        pincode: apiValues.addUserAddressPincode,
        userType: apiValues.addUserType ? apiValues.addUserType : "",
        // type: apiValues.addUserLocation,
      };

      if (this.addUser == true) {
        this.masterService.postData("user", data).subscribe(
          (response: any) => {
            if (response.status == 201 || 200) {
              this.commonHelper.toasterMessage(response.message);
              this.spinner.hide();
              this.router.navigate(["/users"]);
              this.errorOrResponse = true;
            } else {
              this.spinner.hide();
              this.errorOrResponse = false;
              this.commonHelper.toasterMessageError(
                CommonConstants.validationMessage
              );
            }
          },
          (err) => {
            this.spinner.hide();
            this.errorOrResponse = true;
          }
        );
      } else if (this.addUser == false) {
        delete data.password;
        delete data.userName;
        this.masterService.putData("user/", this.userId, data).subscribe(
          (response: any) => {
            if (response.status == 201 || 200) {
              this.commonHelper.toasterMessage(response.message);
              this.spinner.hide();
              this.router.navigate(["/users"]);
              this.errorOrResponse = true;
            } else {
              this.spinner.hide();
              this.errorOrResponse = true;
              this.commonHelper.toasterMessageError(
                CommonConstants.validationMessage
              );
            }
          },
          (err) => {
            this.spinner.hide();
            this.errorOrResponse = true;
          }
        );
      }
      setTimeout(() => {
        this.spinner.hide();
        if (this.errorOrResponse == false) {
          this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
        }
      }, 4000);
    }

  }

  /*get user list*/
  getUsers() {
    try {
      this.spinner.show();
      this.masterService.getAll("user").subscribe((response: any) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            this.spinner.hide();
            this.userData = response.data;
          } else {
            this.userData = [];
            this.spinner.hide();
            this.commonHelper.toasterMessageError(
              CommonConstants.validationMessage
            );
          }
        } else {
          this.spinner.hide();
        }
      });
    } catch (exc) {
      this.spinner.hide();
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
  }

  /**get categories
   *
   * @param stateId
   */
  getCategories() {
    try {
      this.spinner.show();
      this.masterService.getAll("active_grievanceType").subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.spinner.hide();
            if (response.data.length > 0) {
              this.categories = response.data;
            } else {
              this.spinner.hide();
              this.categories = [];
            }
          } else {
            this.spinner.hide();
            this.commonHelper.toasterMessageError(
              CommonConstants.validationMessage
            );
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (exc) {
      this.spinner.hide();
      this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
    }
  }

  getGrievanceNature(id) {
    //this.apiCalling('active_grievanceNature', id)
    try {
      this.spinner.show();
      this.masterService.getData("active_grievanceNature/", id).subscribe(
        (response: any) => {
          if (response.status == 200) {
            let newData = [];
            this.spinner.hide();
            response.data.filter((newResponse) => {
              newData.push({
                id: newResponse.grievanceNatureId,
                name: newResponse.grievanceNatureName,
              });
            });
            if (newData.length > 0) {
              this.spinner.hide();
              this.categoriesNature = newData;
            } else {
              this.categoriesNature = [];
            }
            this.spinner.hide();
          } else {
            this.spinner.hide();
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (excp) {
      this.spinner.hide();
    }
  }

  //  function for nature select
  onNatureChange(value) {
    if (value.length == 0) {
      this.addUserForm.controls["addSelectCategory"].reset();
      this.addUserForm.controls["addUserLevels"].reset();
    }
    if (value.length > 0) {
      this.addUserForm.controls["addUserLevels"].reset();
    }
    this.natureId = [];
    value.map((data) => {
      this.selectedNature = data;
      this.natureId.push(data.id);
    });

    // this.getLevels(this.gId, CommonConstants.stateId, this.natureId);
  }

  /**
   * categorychange
   * @param event
   */
  onAddCategoryChange(event) {
    this.gId = [];
    if (event.length > 0) {
      this.addUserForm.controls["filterGrievanceNature"].reset();
      this.addUserForm.controls["addUserLevels"].reset();
      event.map((data) => {
        this.selectedCategory = data;
        this.gId.push(data.grievanceTypeId);
        this.getGrievanceNature(this.gId);
      });
      // if (this.gId == 4) {
      //   this.getLevels(this.gId, CommonConstants.stateId, this.natureId);
      // }
    }
    // else {
    //   this.gId = 1;
    // }
  }

  // function to append value in input
  onValueChange(val: any) {
    val = this.datepipe.transform(val, "yyyy-MM-dd");
    this.startDateTime = val;
    this.submitted = false;
  }

  // toggle function to show datetime picker modal
  onTogglePicker() {
    if (!this.showPickerStart) {
      this.showPickerStart = true;
    }
  }
}